import React from "react";
import ReactDOM from "react-dom";
import {Media, Image, Button, Form, FormGroup, FormControl, InputGroup} from "react-bootstrap";
import locale from "locale";
import clientAction from "actions/client";
import {getClientAvatar, getClientNickname} from "tools";
import "./style";
import {logout} from "../../../../apiPlayer";

class SendMessageForm extends React.Component {
	messageInput = null;

	state = {
		submitEnabled: false
	};

	onSubmit = () => {};

	constructor(props, context) {
		super(props, context);

		this.handleTextChange = this.handleTextChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
        this.handleLogoutButtonClick = this.handleLogoutButtonClick.bind(this);

		if(props.onSubmit) {
			this.onSubmit = props.onSubmit;
		}
	}

	handleTextChange(e) {
		const value = e.target.value;
		if(value && !this.state.submitEnabled) {
			this.setState({submitEnabled: true});
		} else if(!value && this.state.submitEnabled) {
			this.setState({submitEnabled: false});
		}
	}

	handleSubmit(e) {
		e.preventDefault();

		const input = ReactDOM.findDOMNode(this.messageInput);

		if(!input.value) return;

		this.props.onSubmit({text: input.value});

		input.value = '';
		this.setState({submitEnabled: false});
	}

	handleLogoutButtonClick() {
        const {event} = this.props;

        logout(event.eventKey)
			.then(() => clientAction.setClient(null))
		;
	}

	render() {
		const {client, event} = this.props;

		return (
			<Media className="message-send-form">
				<Media.Left>
					<Image src={getClientAvatar(client)} width="50" rounded />
				</Media.Left>
				<Media.Body>
					<div>
						<span className="message-client">{getClientNickname(client, event.moduleAuth.nickname)}</span>
						<Button bsSize="small" bsStyle="link" onClick={this.handleLogoutButtonClick}>Выйти</Button>
					</div>
					<div>
						<Form onSubmit={this.handleSubmit}>
							<FormGroup bsSize="small">
								<InputGroup>
									<FormControl type="text" onChange={this.handleTextChange} ref={(input) => {this.messageInput = input;}}/>
									<InputGroup.Button>
										<Button type="submit" bsSize="small" bsStyle="primary" disabled={!this.state.submitEnabled}>{locale('message.submit.button')}</Button>
									</InputGroup.Button>
								</InputGroup>
							</FormGroup>
						</Form>
					</div>
				</Media.Body>
			</Media>
		);
	}
}

export default SendMessageForm;
